import { FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Stack, Select, Button, Checkbox, CircularProgress, Autocomplete, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import { As2, BridgeGateSocket, BridgeGateWebService, Database, Email, File, FTP, Http, Socket, Ssh, Cmd, Kafka, AmazonSQS, MqSeries, Msmq, JMS } from '../../../Repository/ConnectionTypes';
import ActiveMQ from '../../../Repository/ConnectionTypes/ActiveMQ';
import Azure from '../../../Repository/ConnectionTypes/Azure';
import GoogleCloudStorage from '../../../Repository/ConnectionTypes/GoogleCloudStorage';
import { MoreHorizOutlined } from '@mui/icons-material';
import Repository from '../../../Repository/Repository';
import BridgeGateHTTP from '../GetData/BridgeGateHTTP/BridgeGateHTTP';
import QualityOfService from './QualityOfService';
import WorkflowEncryptDecrypt from './WorkflowEncryptDecrypt';
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild';
import BridgeGateFTP from '../GetData/BridgeGateFTP/BridgeGateFTP';
import SendDataControls from '../GetData/SendDataControls/SendDataControls';
import WebServiceControls from './WebServiceControls/WebServiceControls';
import SessionData from '../GetData/SessionData/SessionData';
import DataStream from '../../../Repository/ConnectionTypes/DataStream';
import { adapterTypeAdditionalProperties } from '../SendData/SendDataProperties';
import GraphQL from '../../../Repository/ConnectionTypes/GraphQL';

// Helper function to determine if QualityOfService should be shown
const shouldShowQualityOfService = (screen, connectionType, pdcType) => {
  const currentConnectionType = connectionType || pdcType;
  
  // Define exclusion lists based on screen type
  const getDataExclusions = ['BridgeGateHTTP', 'BridgeGateWebService', 'BridgeGate Web Service', 'Data Stream', 'SESSION DATA', 'DATABASE', 'Synchronous Response'];
  const sendDataExclusions = ['DATABASE', 'Synchronous Response'];
  
  // Determine if QoS should be shown
  if (screen === 'GET_DATA') {
    return !getDataExclusions.includes(currentConnectionType);
  } else if (screen === 'SEND_DATA') {
    return !sendDataExclusions.includes(currentConnectionType);
  }
  
  return true; // Default to showing QoS for other screens
};

function WorkflowConnectionPanel({ source, screen, connectionDetails, handleConnectionDetailsChange ,node}) {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector(state => state.treeData?.[parentScreen]);
    const currentTab = rightTree?.currentTab;
    const selectedNode = rightTree?.tree?.[currentTab]?.selectedNode;
    const dispatch = useDispatch();
    const { account } = useSelector(state => state.queryParams)
    const [useConnection, setUseConnection] = useState('current');
    const [connectionType, setConnectionType] = useState('');
    const [adapterTypes, setAdapterTypes] = useState([]);
    const [pdcDropdownOptions, setPdcDropdownOptions] = useState([])
    const [pdc, setPDC] = useState(t('SELECT'));
    const [pdcType, setPdcType] = useState('')
    const [pdcModal, setPdcModal] = useState(null);
    const [overridePdc, setOverridePdc] = useState(false);
    const [pdcWithDetails,setPdcWithDetails] = useState([]);
    const [linkInfo, setLinkInfo] = useState(connectionDetails);
    const [repoPDC, setRepoPDC] = useState({});
    const [changedKeys, setChangedKeys] = useState({})
    const [loadingData, setLoadingData] = useState(false)
    const [synchronousNodes, setSynchronousNodes] = useState([]);
    const [synchronousGetDataNodes, setSynchronousGetDataNodes] = useState([]);
    const listUpdated = useSelector((state) => state.treeData.pdcListUpdated);
    
    // connection type dropdown options based on screen type
    const connectionTypeEndPoint = {
        GET_DATA:'getGetDataAdapterList',
        SEND_DATA:'getSendDataAdapterList',
        // Add options for other screens
    }
    const connectionTypeOptions = adapterTypes.map((obj, key) => (
        <MenuItem key={key} value={t(obj)}>
          {t(obj)}
        </MenuItem>
      ));
    
    const preDefinedOptions = pdcDropdownOptions.map((obj, key) => (
      <MenuItem key={key} value={t(obj)}>
        {t(obj)}
      </MenuItem>
    )); 
    // use current or pre defined 
    const handleConnectionChange = (e) => {
      const { value } = e.target;
      setUseConnection(value);
      if(value === 'current') setPDC(t('SELECT'))
      setConnectionType(connectionDetails?.ADAPTER_TYPE)
       // Delete all values from connectionDetails except 'ADAPTER_TYPE' when connection is switched 
      // if((value === 'current' && connectionDetails?.hasOwnProperty('PREDEFINED')) || (value === 'preDefined' && pdc !== t('SELECT')) ){
        if((value === 'current') || (value === 'preDefined' && pdc !== t('SELECT')) ){

        setLinkInfo(prev => null)
        handleConnectionDetailsChange({add :{ connDetailUpdateFlag: "current", PREDEFINED: null, OVERRIDE: null , ...(removeOnOverrideFalse[connectionDetails?.ADAPTER_TYPE])}})
        setOverridePdc(false);
      } 
      // else {
      //   handleConnectionDetailsChange({ add: { connDetailUpdateFlag: "predefined" } })
      // }
    }
    // Adapter type change
    const handleConnectionTypeChange = (e) => {
      if (!e?.target?.value) {
        console.warn("No value found in connection type dropdown");
        return;
      }
      if(e.target.value === "BridgeGate Web Service") {
        setConnectionType("BridgeGateWebService");
        handleConnectionDetailsChange({ADAPTER_TYPE: "BridgeGateWebService"});
      }else {
        setConnectionType(e.target.value);
        if (source === "ERROR_HANDLER" && screen === "SEND_DATA") {
          handleConnectionDetailsChange({add: {
            ADAPTER_TYPE: e.target.value, 
            ...(removeOnOverrideFalse[e.target.value]),
            ...(adapterTypeAdditionalProperties[e.target.value])
          }});
        }else{
          handleConnectionDetailsChange({ADAPTER_TYPE: e.target.value});
        }
      }
      setPdcType('');
    }
    // Pre-Defined connection change
    const handlePdcChange = (event, newValue) => {
      const value = newValue || t('SELECT');
      
      // If value is SELECT (cleared), reset states
      if (value === t('SELECT')) {
        setPDC(t('SELECT'));
        setPdcType('');
        setLinkInfo(null);
        setRepoPDC({});
        setConnectionType('');
        setOverridePdc(false);
        return;
      }
      
      const details = getSelectedPdcDetails(pdcWithDetails, value);// get details of selected pdc
      
      // Only proceed if we have valid details
      if (!details) {
        console.warn('No details found for selected PDC:', value);
        return;
      }
      
      setPDC(value);
      setPdcType(details?.ADAPTER_TYPE);
      setLinkInfo(details);
      setRepoPDC(details);
      setConnectionType(details?.ADAPTER_TYPE);
      setOverridePdc(false);

      const newConnectionDetails = { PREDEFINED: value, OVERRIDE:'FALSE', ADAPTER_TYPE: details?.ADAPTER_TYPE }
      const removals = removeOnOverrideFalse[details?.ADAPTER_TYPE] || {};
      const finalAdd = { ...newConnectionDetails, ...removals };
      if (details?.SYNCHRONOUS) finalAdd.SYNCHRONOUS = details.SYNCHRONOUS;
      handleConnectionDetailsChange({add: finalAdd})
    }

    // Handle PDC selection from Repository component
    const handlePdcSelection = (selectedPdcData) => {
      if (selectedPdcData.connectionName && selectedPdcData.connectionDetails) {
        const pdcName = selectedPdcData.connectionName;
        const pdcDetails = selectedPdcData.connectionDetails;
        
        // Update states directly with selected data
        setPDC(pdcName);
        setPdcType(pdcDetails.ADAPTER_TYPE);
        setLinkInfo(pdcDetails);
        setRepoPDC(pdcDetails);
        setConnectionType(pdcDetails.ADAPTER_TYPE);
        setOverridePdc(false);
        
        // Update connection details
        const newConnectionDetails = { 
            PREDEFINED: pdcName, 
            OVERRIDE:'FALSE',
            ADAPTER_TYPE: pdcDetails.ADAPTER_TYPE 
        };
        const removals = removeOnOverrideFalse[pdcDetails.ADAPTER_TYPE] || {};
        const finalAdd = { ...newConnectionDetails, ...removals };
        if (pdcDetails?.SYNCHRONOUS) finalAdd.SYNCHRONOUS = pdcDetails.SYNCHRONOUS;

        handleConnectionDetailsChange({add: finalAdd});
        
        // Refresh the PDC dropdown to include the newly selected PDC
        setTimeout(() => {
            setUseConnection('preDefined');
        }, 100);
      }
    }
    //Override checkbox change
    const handleOverrideChange = (value) => {
      setOverridePdc(value);
      if(!value) {
        const details = getSelectedPdcDetails(pdcWithDetails, pdc);
        setLinkInfo({ ...details });
      }
      handleConnectionDetailsChange({add : {OVERRIDE: value ? 'TRUE' : 'FALSE', ...(value  ? {} : removeOnOverrideFalse[connectionDetails?.ADAPTER_TYPE])}})
    }
    // Function that return Connection info of selected pdc
    const getSelectedPdcDetails = (pdcWithDetails, pdcName) => {
      for(const pdc of pdcWithDetails){
        if(pdc[pdcName]){
          return pdc[pdcName]
        }
      }
      return null;
    }
    // Diff function Original PDC vs OVERRIDDEN data
    const getPdcDiffAfterOverride = (originalPdc, currentConnectionDetails) => {
      const newObj = { ...originalPdc }; 
      const changedKeys = {};
    
      for (const key in currentConnectionDetails) {
        if (!originalPdc?.hasOwnProperty(key)) {
          newObj[key] = currentConnectionDetails[key];
          if(currentConnectionDetails[key]) changedKeys[key] = currentConnectionDetails[key];
        } else if (originalPdc[key] !== currentConnectionDetails[key]) {
          newObj[key] = currentConnectionDetails[key];
          changedKeys[key] = currentConnectionDetails[key];
        }
      }
    
      return { newObj, changedKeys };
    };
    
    
    useEffect(() => {
      const fetchData = async () => {
        if (!screen) return;
        try {
          const res = await dispatch(
            api.endpoints[connectionTypeEndPoint[screen]].initiate({ account }, { forceRefetch: true })
          );
          if (res?.data?.current_state === "SUCCESS") {
            
            if (source === "ERROR_HANDLER") {
              setAdapterTypes(res?.data?.data?.filter((item) => (item !== "Synchronous Response" && item !== "BridgeGateFTP")));
            } else {
              setAdapterTypes(res?.data?.data);
            }
            
            if (useConnection === "current") {
              // setConnectionType((prev) => connectionDetails?.ADAPTER_TYPE);
              if(source === "ERROR_HANDLER") {
                setConnectionType(connectionDetails?.ADAPTER_TYPE)
                setPdcType(connectionDetails?.PREDEFINED)
              } else {
                setConnectionType(selectedNode?.ICON_DISPLAY === "GET_DATA" ? selectedNode?.INBOUND?.ADAPTER_TYPE : selectedNode?.OUTBOUND?.ADAPTER_TYPE)
              }
              // setLinkInfo(connectionDetails)
            }
          } else {
            setAdapterTypes([]);
          }
        } catch (error) {
          console.error("Error fetching adapter types:", error);
        }

        if (useConnection === "preDefined") {
          setLoadingData(true);

          try {
            const response = await dispatch(
              api.endpoints.getAllPdcDetail.initiate(
                { account, direction: selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT" },
                { forceRefetch: true }
              )
            );

            if (response?.data?.predefined_connections) {
              let pdcDetails = [...response.data.predefined_connections].sort(
                (a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0])
              );

              const details = getSelectedPdcDetails(pdcDetails, pdc);
              const inPDC = pdcDetails.map((item) => Object.keys(item)[0]);

              setPdcDropdownOptions([t("SELECT"), ...inPDC]);
             
              setPdcWithDetails(pdcDetails);
              if(pdc !== t("SELECT")) {
                setPdcType(details ? details?.ADAPTER_TYPE : connectionDetails?.ADAPTER_TYPE);
                setConnectionType(details ? details?.ADAPTER_TYPE : connectionDetails?.ADAPTER_TYPE);
              }
              setOverridePdc(connectionDetails?.OVERRIDE === "TRUE");
              // if (pdc !== t("SELECT"))
                // handleConnectionDetailsChange({
                //   ADAPTER_TYPE: details?.ADAPTER_TYPE,
                // });
              setRepoPDC(details);
              if (connectionDetails?.OVERRIDE === "TRUE") {
                const { newObj, changedKeys } = getPdcDiffAfterOverride(
                  details,
                  connectionDetails
                );
                setLinkInfo(newObj);
                setChangedKeys(changedKeys);
              } else {
                if (pdc !== t("SELECT")) {
                  setLinkInfo(details);

                  if (connectionDetails?.PREDEFINED === pdc && connectionDetails?.OVERRIDE !== 'TRUE') {
                    const newSync = details?.SYNCHRONOUS ?? null;
                    if (connectionDetails?.SYNCHRONOUS !== newSync) {
                      handleConnectionDetailsChange({ add: { SYNCHRONOUS: newSync } });
                    }
                  }
                }
              }
            } else {
              setPdcDropdownOptions([t("SELECT")]);
            }
          } catch (error) {
            console.error("Error fetching predefined connections:", error);
          }
        }
      };

      fetchData().finally(() => setLoadingData(false));
    }, [useConnection, pdcModal, listUpdated]);
  
    useEffect(() => {
      if(connectionDetails?.hasOwnProperty('PREDEFINED')){
        setUseConnection('preDefined');
        setPDC(connectionDetails?.PREDEFINED || t("SELECT"));
      } else {
        setUseConnection('current')
      }
      return () => {
        setPDC(t("SELECT"))
      }
    },[connectionDetails]) 
    
    useEffect(() => {
      if (useConnection === "current") {
        setLinkInfo(connectionDetails);
      }
    }, [useConnection, connectionDetails]); 

  return (
    <div>
        <Stack spacing='15px'>
            <FormControl variant='outlined' className='width-100' size='small'>
                <FormLabel id="connection-buttons">{t('LBL_SELECT_CONN_INFO')}</FormLabel>
                <RadioGroup
                    aria-labelledby="connection-buttons"
                    name="connection-btn"
                    row
                    value={useConnection}
                    onChange={handleConnectionChange}
                >
                    {
                     (connectionType !== "BridgeGateHTTP") &&
                      <FormControlLabel value="preDefined" control={<Radio disabled={["BridgeGateHTTP"].includes(connectionType)}/>} label={t('BTN_PREDEF_CONN')} />
                    }
                    <FormControlLabel value="current" control={<Radio />} label={t('BTN_CURRENT_CONNECTION')} />
                </RadioGroup>
            </FormControl>
            {useConnection === 'preDefined' && (
              <>
                <div style={{display:'flex', gap:'4px'}}>
                <Autocomplete
                  freeSolo
                  size='small'
                  className='width-100'
                  options={pdcDropdownOptions.map(option => t(option))}
                  value={pdc}
                  onChange={handlePdcChange}
                  ListboxProps={{
                    style: {
                      maxHeight: 300
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('BTN_PREDEF_CONN')}
                      variant="outlined"
                      onChange={(e, val) => {
                        handlePdcChange(e, e.target.value)
                      }}
                    />
                  )}
                />
                <Button size='small' variant='outlined' onClick={() => setPdcModal(5)} sx={{width: '40px', minWidth:'40px'}}>
                  <MoreHorizOutlined fontSize='small' />
                </Button>
                <Repository 
                  option={pdcModal} 
                  setOption={setPdcModal} 
                  handleClose={() => setPdcModal(null)} 
                  dir={screen === 'GET_DATA' ? 'IN' : 'OUT'} 
                  pdcName={pdc !== t('SELECT') ? pdc : ''} 
                  screen={screen}
                  onPdcSelect={handlePdcSelection}
                />
                </div> 
                {pdc !== t('SELECT') && repoPDC?.ADAPTER_TYPE !== "BridgeGateWebService" && repoPDC?.ADAPTER_TYPE !== "BridgeGate Web Service" && <div>
                   <FormControlLabel
                      label={t('BTN_OVERRIDE_PREDIFINED')}
                      sx={{height: '30px'}}
                      className={'width-fit-content'}
                      control={
                        <Checkbox
                          checked={overridePdc}
                          size='small' 
                          name='overridePdc'
                          onChange={(e, checked) => {
                            handleOverrideChange(checked)
                          }
                        } />
                      }
                    />
                </div>}
              </>
            )}
            {(useConnection === 'current' || (useConnection === 'preDefined' && pdc !== t('SELECT'))) && (
            loadingData ? <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}><CircularProgress /> </div>:
              (<>
                <FormControl>
                    <InputLabel id='connectionType'>{t('CONNECTION_TYPE')}</InputLabel>
                    <Select 
                       size='small' 
                       className='width-100'
                       disabled={useConnection === 'preDefined'}
                       MenuProps={{
                         PaperProps: {
                           sx: {
                            maxHeight: 300 
                           }
                         }
                       }}
                       value={(connectionType === "BridgeGateWebService" ? "BridgeGate Web Service" : connectionType )|| (pdcType === "BridgeGateWebService" ? "BridgeGate Web Service" : pdcType)} 
                       onChange={handleConnectionTypeChange}
                    >
                        {connectionTypeOptions}
                    </Select>
                </FormControl>
                {(connectionType === 'BridgeGateSocket' || pdcType === 'BridgeGateSocket')  && (
                    <BridgeGateSocket repoPDC={repoPDC} connectionDetails={linkInfo} handleBodyContent={handleConnectionDetailsChange} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} changedKeys={changedKeys} useConnection={useConnection} />
                )}
                {(connectionType === 'FILE' || pdcType === 'FILE') && (
                  <File fileMaskName={node?.SOURCE_FILE_MASK} connectionDetails={linkInfo} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} screen={screen} useConnection={useConnection} disableControl={!overridePdc && useConnection === 'preDefined'} />
                )}
                {(connectionType === 'DATABASE' || pdcType === 'DATABASE') && (
                  <Database connectionDetails={linkInfo} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} disableControl={!overridePdc && useConnection === 'preDefined'} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} screen={screen} changedKeys={changedKeys} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'BridgeGateHTTP' || pdcType === 'BridgeGateHTTP') && (
                  <BridgeGateHTTP connectionDetails={linkInfo} handleBodyContent={handleConnectionDetailsChange} direction={'IN'} screen='GET_DATA' />
                )}
                {(connectionType === 'BridgeGateFTP' || pdcType === 'BridgeGateFTP') && (
                  <BridgeGateFTP fileMaskName={node?.SOURCE_FILE_MASK} connectionDetails={linkInfo} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection}  />
                )}
                {(connectionType === 'Synchronous Response' || pdcType === 'Synchronous Response') && (
                  <SendDataControls 
                    connectionDetails={linkInfo} 
                    handleBodyContent={handleConnectionDetailsChange} 
                    sendSynchronousNodeData={(nodes) => setSynchronousNodes(nodes)} 
                    sendSynchronousGetDataNodeData={(nodes) => setSynchronousGetDataNodes(nodes)} 
                    screen={screen} 
                    disableControl={!overridePdc && useConnection === 'preDefined'} 
                    useConnection={useConnection}
                    repoPDC={repoPDC}
                  />
                )}
                {(connectionType === 'AS2' || pdcType === 'AS2') && (
                  <As2 connectionDetails={linkInfo} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {(connectionType === t("SESSION_DATA") || pdcType === t("SESSION_DATA")) && (
                  <SessionData connectionDetails={linkInfo} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction='IN' screen='GET_DATA' disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {(connectionType === 'EMAIL' || pdcType === 'EMAIL') && (
                  <Email connectionDetails={linkInfo} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} repoPDC={repoPDC}  handleBodyContent={handleConnectionDetailsChange} account={account} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'Web Service' || pdcType === 'Web Service')  && (
                  <WebServiceControls connectionDetails={linkInfo} disableControls={!overridePdc && useConnection === 'preDefined'} repoPDC={repoPDC} useConnection={useConnection}  handleBodyContent={handleConnectionDetailsChange} screen={screen} />
                )}
                {(connectionType === 'BridgeGateWebService' || pdcType === 'BridgeGateWebService' || connectionType === "BridgeGate Web Service" || pdcType === "BridgeGate Web Service") && (
                  <BridgeGateWebService connectionDetails={linkInfo} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source}/>
                )}
                {(connectionType === 'SOCKET' || pdcType === 'SOCKET') && (
                  <Socket connectionDetails={linkInfo} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {(connectionType === 'FTP' || pdcType === 'FTP') && (
                  <FTP connectionDetails={linkInfo} fileMaskName={node?.SOURCE_FILE_MASK} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'Azure' || pdcType === 'Azure') && (
                  <Azure connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {((connectionType === 'Google Cloud Storage' || pdcType === 'Google Cloud Storage' || connectionType === 'Google_Cloud_Storage' || pdcType === 'Google_Cloud_Storage') ) && (
                  <GoogleCloudStorage connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {(connectionType === 'MQ Series' || pdcType === 'MQ Series') && (
                  <MqSeries connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'BridgeGateMQSeries' || pdcType === 'BridgeGateMQSeries') && (
                  <MqSeries connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'AmazonSQS' || pdcType === 'AmazonSQS') && (
                  <>
                    <AmazonSQS connectionDetails={linkInfo} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} screen={screen} useConnection={useConnection} repoPDC={repoPDC} disableControl={!overridePdc && useConnection === 'preDefined'} />
                  </>
                )}
                {(connectionType === 'MSMQ' || pdcType === 'MSMQ') && (
                  <Msmq connectionDetails={linkInfo} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} screen={screen} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} repoPDC={repoPDC} source={source} />
                )}
                {(connectionType === 'SSH' || pdcType === 'SSH') && (
                  <Ssh connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'Command Prompt' || pdcType === 'Command Prompt') && (
                  <Cmd source={source} connectionDetails={linkInfo} fileMaskName={node?.SOURCE_FILE_MASK} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {(connectionType === 'Kafka' || pdcType === 'Kafka') && (
                  <Kafka connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'ActiveMQ' || pdcType === 'ActiveMQ') && (
                  <ActiveMQ connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} />
                )}
                {(connectionType === 'HTTP' || pdcType === 'HTTP') && (
                  <Http connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'BridgeGateMSMQ' || pdcType === 'BridgeGateMSMQ') && (
                  <Msmq connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'GraphQL' || pdcType === 'GraphQL') && (
                  <GraphQL connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                )}
                {(connectionType === 'JMS' || pdcType === 'JMS') && (
                  <JMS connectionDetails={linkInfo} screen={screen} repoPDC={repoPDC} handleBodyContent={handleConnectionDetailsChange} direction={selectedNode?.ICON_DISPLAY === "GET_DATA" ? "IN" : "OUT"} account={account} disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} source={source} />
                  )}
                {/* Other connection Types */}

                {/* Exclusive Send data connection types */}
                {screen === 'SEND_DATA' && (connectionType === 'Data Stream' || pdcType === 'Data Stream') && (
                  <DataStream connectionDetails={linkInfo} handleBodyContent={handleConnectionDetailsChange}  disableControl={!overridePdc && useConnection === 'preDefined'} useConnection={useConnection} repoPDC={repoPDC} screen={screen} />
                )}
                {/* Common components */}
                 {source !== 'ERROR_HANDLER' && shouldShowQualityOfService(screen, connectionType, pdcType) && (
                    <QualityOfService connectionDetails={connectionDetails} updateAndSaveData={handleConnectionDetailsChange} showEnhancedQOS={selectedNode?.ICON_DISPLAY === "SEND_DATA" && ["BridgeGateFTP", "FTP", "Data Stream", "FILE", "Command Prompt", "Kafka", "AmazonSQS", "SSH", "HTTP", "EMAIL", "ActiveMQ", "AS2", "Azure", "SOCKET", "MQ Series", "MSMQ", "Web Service", "GraphQL", "Google Cloud Storage"].includes(connectionType || pdcType)} screen={screen} />
                 )}
                 {source !== 'ERROR_HANDLER' && ((  ["Data Stream","BridgeGateHTTP", "BridgeGateFTP", "EMAIL", "SOCKET", "Web Service", "FTP", "SSH", "Command Prompt", "Kafka", "ActiveMQ", "AmazonSQS", "HTTP", "AS2", "Azure", "FILE", "MQ Series", "MSMQ", "BridgeGateMSMQ", "BridgeGateMQSeries", "BridgeGateWebService", "GraphQL", "Google Cloud Storage", "JMS"].includes(connectionType || pdcType)) || ( "Synchronous Response" === (connectionType || pdcType) && (synchronousNodes?.find(node => node?.ID === selectedNode?.SYNC_SEND_DATA_ID)?.OUTBOUND?.ADAPTER_TYPE === "HTTP" || synchronousGetDataNodes?.find(node => node?.ID === selectedNode?.SYNC_GET_DATA_ID)?.INBOUND?.ADAPTER_TYPE === "HTTP"))) &&
                     <WorkflowEncryptDecrypt 
                        connectionDetails={connectionDetails} 
                        disableEncrypt={selectedNode?.OUTBOUND?.hasOwnProperty("ZIP") || selectedNode?.INBOUND?.hasOwnProperty("ZIP") || ((connectionType === 'AS2' || pdcType === 'AS2') && (selectedNode?.OUTBOUND?.AS2_COMPRESSION === 'TRUE' || selectedNode?.INBOUND?.AS2_COMPRESSION === 'TRUE' || repoPDC?.AS2_COMPRESSION === 'TRUE' || connectionDetails?.AS2_COMPRESSION === 'TRUE' || linkInfo?.AS2_COMPRESSION === 'TRUE')) } 
                        updateAndSaveData={handleConnectionDetailsChange} 
                        screen={screen}
                        selectedNode={selectedNode}
                      />
                 }
            </>)
        )}
        </Stack>
    </div>
  )
}

export default WorkflowConnectionPanel

// Props Description
//    -screen : Parent Component
//    -connectionDetails : details about selected connection type(like for BridgegateSocket - Port, end of Delimiter etc)
//    -handleConnectionDetailsChange : Function to update Connection details


const removeOnOverrideFalse = {
  BridgeGateSocket: {
    'PORT': null,            
    'EOD_TERMINATOR':null,  
    'TIMEOUT': null,       
    'KEEP_ALIVE': null,     
    'USE_SINGLE_CONN': null, 
    'SSL': null,      
    'SYNCHRONOUS': 'FALSE',
  },
  DATABASE: {
    'DATABASE_TYPE': null,            
    'JDBCURL':null,  
    'USERNAME': null,       
    'PASSWORD': null,
    'TRANSACTION_TYPE': null,
    'DB_WRITE_THREADS': null,     
  },
  FILE: {
    "FILE_LOCATION": null,
    "FILENAMEMASK": null,
    "ZIP_PASSWORD":null,
    "USE_ZIP_PASSWORD": null,
    "ZIP": null,
    "DECOMPRESSION_DIRECTORY": null,
    "SPECIFY_DECOMPRESSION_DIRECTORY": null,
    "DO_NOT_PROCESS_DUPLICATE_FILES": null,
    "FILETIME_FILTER": null,
    "FILETIME_FILTER_MAX": null,
    "SORT_BY": null,
    "SORT_ORDER": null,
    "FILE_FILTER_PLUGIN": null,
    "RUN_ON_SERVER": null,
    // "DONT_RETAIN_PLAIN_TEXT": null,
    // "ENCRYPTION_TYPE": null,
    // "ENCRYPTION_PARAM1": null,
    // "RETRY_COUNT": null,
    // "TIME_BEFORE_RETRY": null,
    // "ENCODING": null,
    "DELETE": null,
    "APPEND_FILE": null,
    "COMPRESSION_TYPE": null,
    "FILE_NAME_WITHIN_ZIP": null,
    "FILENAME":null
  },
  BridgeGateHTTP: {
    "ADAPTER_TYPE" : null, 
    "AUTHENTICATE" : null,
    "DO_NOT_PROCESS_DUPLICATE_FILES" : null,
    // "ENCODING" : null,
    "REC_POST_DATA" : null,
    "USE_WSDL" : null,
    //defaults below
    // "ADAPTER_TYPE" : "BridgeGateHTTP", 
    // "AUTHENTICATE" : "TRUE",
    // "DO_NOT_PROCESS_DUPLICATE_FILES" : "false",
    // "ENCODING" : "UTF-8",
    // "REC_POST_DATA" : "FALSE",
    // "USE_WSDL" : "FALSE"
  },
  BridgeGateFTP: {
    "ACCOUNT" : null,
    "TRADING_PARTNER_NAME" : null,
    "DELETE" : null,
    // "DONT_RETAIN_PLAIN_TEXT" : null,
    // "ENCRYPTION_TYPE" : null,
    // "ENCRYPTION_PARAM1" : null,
    // "RETRY_COUNT" : null,
    // "TIME_BEFORE_RETRY" : null,
    "FILE_LOCATION" : null,
    "FILENAMEMASK" : null,
    "SPECIFY_DECOMPRESSION_DIRECTORY" : null,
    "DECOMPRESSION_DIRECTORY" : null,
    "USE_ZIP_PASSWORD" : null,
    "ZIP_PASSWORD" : null,
    "ZIP" : null,
    "SSH": null,
    "FILENAME": null,
    "FILE_NAME_WITHIN_ZIP": null,
  },
  AS2: {
    "SENDER_AS2_ID" : null,
    "AS2_ID" : null, 
    "NAME" : null,
    "X509_ALIAS_SIGNING" : null,
    "X509_ALIAS_ENCRYPTION" : null,
    "X509_ALIAS_HTTPS" : null,
    "EMAIL" : null, 
    "AS2_URL" : null,
    "AS2_TRANSPORT" : null,
    "AS2_SECURITY " : null,
    "AS2_SIG_ALG" : null, 
    "AS2_ENC_ALG" : null,
    "AS2_COMPRESSION" : null, 
    "AS2_MDN_TRANSPORT" : null,
    "AS2_MDN_URL" : null,
    "AS2_MDN_SECURITY" : null,
    "AS2_FILE_NAME" : null
  },
  "Web Service": {
    "USE_WSDL": null,
    "WSDL_PATH": null,
    "WSDL_BINDING": null,
    "WSDL_BINDING_OPERATION": null,
    "WSDL_BINDING_SERVICE": null,
    "CONNECTIONSTRING": null,
    "TARGET_NAMESPACE": null,
    "REQUEST_ELEMENT_NAME": null,
    "SOAP_ACTION": null,
    "SOAP_PREFIX": null,
    "AUTHENTICATE": null,
    "USERNAME": null,
    "PASSWORD": null,
    "REALM": null,
    "TIMEOUT": null,
    "KEY_ALIAS": null,
    "SSL_TYPE": null,
    "WRITE_SOAP_BODY": null,
    "MAINTAIN_SESSION": null,
    "HTTP_CUSTOM_HEADER_FIELDS": null,
    "WSDL_CACHED": null,
    "WSDL_CACHE_TIME": null,
    "WSDL_CACHED_PATH": null,
    "ARGS": null,
  },
  "BridgeGateWebService": {
    "CONNECTIONSTRING": null,
    "SERVICE_NAME": null,
    "TARGET_NAMESPACE": null,
    "AUTHENTICATE": null,
    "USERNAME": null,
    "PASSWORD": null,
    "SOAP_USE_ENVELOPE_AS_RESULT": null,
    "WRITE_SOAP_BODY": null,
    "SEND_SOURCE_AS_SOAP_BODY": null,
    "SYNCHRONOUS": null,
  },
  EMAIL: {
    "CONNECTIONSTRING": null,
    "SSL" : null,
    "PORT" : null,
    "TLS" : null,
    "USERNAME" : null,
    "PASSWORD" : null,
    "AUTH_TYPE" : null,
    "TENANT_ID" : null,
    "CLIENT_ID" : null,
    "CLIENT_SECRET" : null,
    "MAIL_TYPE" : null,
    "GET_EMAIL_TYPE" : null,
    "AFTER_READ_ACTION" : null,
    "READ_FROM_ATTACHMENT" : null,
    "DECOMPRESSION_DIRECTORY" : null,
    "SPECIFY_DECOMPRESSION_DIRECTORY" : null,
    "USE_ZIP_PASSWORD" : null,
    "ZIP_PASSWORD": null,
    "ZIP": null,
    // SEND_DATA specific keys
    "TO_EMAIL": null,
    "FROM_EMAIL": null,
    "CC_EMAIL": null,
    "BCC_EMAIL": null,
    "SUBJECT": null,
    "MESSAGE_ID": null,
    "OUTPUT_AS_ATTACHMENT": null,
    "FILENAME": null,
    "REQUIRES_AUTHENTICATION": null,
    "COMPRESSION": null,
    "COMPRESSION_TYPE": null,
    "FILE_NAME_WITHIN_ZIP": null,
    "BODY": null,
    "HTML_CONTENT": null,
    "CREDENTIALS_JSON": null,
    "REFRESH_TOKEN": null,

  },
  SOCKET: {
    "CONNECTIONSTRING": null,
    "PORT": null,
    "EOD_TERMINATOR": null,
    "TIMEOUT": null,
    "KEEP_ALIVE": null,
    "KEY_ALIAS": null,
    "SYNCHRONOUS": null,
    "SSL": null,
  },
  FTP: {
    "CONNECTIONSTRING": null,
    "ACCOUNT": null,
    "FILE_LOCATION": null,
    "FILENAMEMASK": null,
    "PASSWORD": null,
    "USERNAME": null,
    "DECOMPRESSION_DIRECTORY": null,
    "USE_ZIP_PASSWORD": null,
    "ZIP_PASSWORD": null,
    "ZIP": null,
    "BATCH_DOWNLOAD_LOCAL": null,
    "BATCH_MODE": null,
    "DELETE": null,
    "ASCII": null,
    "CACHE_CONNECTION": null,
    "PASSIVE_MODE": null,
    "DO_NOT_PROCESS_DUPLICATE_FILES":null,
    "POST_FTP_SCRIPT": null,
    "PRE_FTP_SCRIPT": null,
    "KEY": null,
    "KEY_PASSWORD": null,
    "SSH": null,
    "SSL":null,
    "SSL_STRATEGY": null,
  },
  SSH: {
    "CONNECTIONSTRING": null,
    "USERNAME": null,
    "PASSWORD": null,
    "SSH_SCRIPT": null,
    "USE_WSDL": null,
  },
 "Command Prompt": {
    "EXECUTABLE": null,
    "CMD_ARGS": null,
    "FILENAME": null,
    "STREAM_ARGS": null,
    "STREAM_DATA": null,
    "ZIP": null,
    "COMPRESSION": null,
    "COMPRESSION_TYPE": null,
    "FILE_NAME_WITHIN_ZIP": null,
    "SPECIFY_DECOMPRESSION_DIRECTORY": null,
    "DECOMPRESSION_DIRECTORY": null,
    "USE_ZIP_PASSWORD": null,
    "ZIP_PASSWORD": null,
    "SCRIPT": null,
  },
  "Data Stream": {
    "USE_CALL_WF_FOR_DATASTREAM": null,
    "CWF_WF_GROUP": null,
    "CWF_WORKFLOW": null,
    "CWF_ACCOUNT": null,
    "CWF_RUN_CONCURRENT": null,
    "CWF_RUN_DISTRIBUTED": null,
    "CWF_MAX_CONCURRENT_THREADS": null,
    "CWF_IGNORE_ERRORS": null,
  },
  "Kafka": {
    "TOPIC_NAME": null,
    "BOOTSTRAP_SERVERS_CONFIG": null,
    "GROUP_ID_CONFIG": null,
    "KEY_DESERIALIZER_CLASS_CONFIG": null,
    "VALUE_DESERIALIZER_CLASS_CONFIG": null,
    "CLIENT_ID_CONFIG": null,
    "KEY_SERIALIZER_CLASS_CONFIG": null,
    "VALUE_SERIALIZER_CLASS_CONFIG": null,
    "ENABLE_AUTO_COMMIT_CONFIG": null,
    "AUTO_OFFSET_RESET_CONFIG": null,
    "TIMEOUT": null,
    "AUTH_TYPE": null,
    "USERNAME": null,
    "PASSWORD": null,
    "SSL_TYPE": null,
    "KEYSTORE": null,
    "KEYSTORE_PWD": null,
    "KEY_PWD": null,
    "TRUSTSTORE": null,
    "TRUSTSTORE_PWD": null
  },
  HTTP: {
    "CONNECTIONSTRING": null,
    "USERNAME": null,
    "PASSWORD": null,
    "KEY_ALIAS": null,
    "HTTP_TIMEOUT": null,
    "URLENCODE": null,
    "FORCE_HOST_VERIFICATION": null,
    "SYNCHRONOUS": null,
    "SSL_TYPE": null,
    "REQUEST_TYPE": null,
    "CONTENT_TYPE": null,
    "SOAP_ACTION": null,
    "ZIP": null,
    "FILE_NAME_WITHIN_ZIP": null,
    "ZIP_PASSWORD": null,
    "USE_ZIP_PASSWORD": null,
    "DECOMPRESSION_DIRECTORY": null,
    "SPECIFY_DECOMPRESSION_DIRECTORY": null,
    "HTTP_CUSTOM_HEADER_FIELDS": null,
    "HTTP_QUERY_PARAMETERS": null,
    "COMPRESSION": null,
    "COMPRESSION_TYPE": null,
    "FORM_DATA": null,
  },
  "ActiveMQ": {
    "TIMEOUT": null,
    "INIT_URL": null,
    "DESTINATION_TYPE": null,
    "QUEUE_OR_TOPIC_NAME": null,
    "DURABLE_SUBSCRIPTION_CLIENT_ID": null
  },
  "MQ Series": {
    "CONNECTION_FACTORY_LOOKUP": null,
    "DESTINATION_TYPE": null,
    "QUEUE_OR_TOPIC_NAME": null,
    "DURABLE_SUBSCRIPTION_CLIENT_ID": null,
    "HOST_NAME": null,
    "PORT": null,
    "USERNAME": null,
    "PASSWORD": null,
    "CHANNEL": null,
    "TRANSACTIONAL": null,
    "SSL": null,
    "CIPHER": null,
    "RUN_ON_PRIMARY": null
  },
  "BridgeGateMQSeries": {
    "CONNECTION_FACTORY_LOOKUP": null,
    "DESTINATION_TYPE": null,
    "QUEUE_OR_TOPIC_NAME": null,
    "DURABLE_SUBSCRIPTION_CLIENT_ID": null,
    "HOST_NAME": null,
    "PORT": null,
    "USERNAME": null,
    "PASSWORD": null,
    "CHANNEL": null,
    "TRANSACTIONAL": null,
    "SSL": null,
    "CIPHER": null,
    "RUN_ON_PRIMARY": null
  },
  Azure: {
    "AZURE_ACCOUNT_NAME": null,
    "AZURE_ACCOUNT_KEY": null,
    "AZURE_FILESYSTEM": null,
    "CREATE_FILESYS": null,
    "AZURE_DIRECTORY": null,
    "CREATE_DIRS": null,
    "AZURE_FILENAME": null,
    "DELETE": null,
    "APPEND_FILE": null,
  },
  AmazonSQS: {
    "URL": null,
    "ACCESS_KEY_ID": null,
    "SECRET_KEY_ID": null,
    "TIMEOUT": null,
    "DURABLE_SUBSCRIPTION_CLIENT_ID": null,
    "MESSAGE_GROUP_ID": null,
    "DONT_RETAIN_PLAIN_TEXT": null,
    "ENCRYPTION_TYPE": null,
    "ENCRYPTION_PARAM1": null,
    "RETRY_COUNT": null,
    "TIME_BEFORE_RETRY": null,
    "ENCODING": null,
    "ALERT": null,
    "ERROR_HANDLER_ID": null,
    "GUARANTY_DELIVERY": null,
  }, 
  "Synchronous Response": {
    "HTTP_RESPONSE_CODE": null,
    "HTTP_CONTENT_TYPE": null,
    "OVERRIDE_HTTP_RESPONSE_CODE": null,
    "OVERRIDE_HTTP_CONTENT_TYPE": null,
    "SYNC_GET_DATA_ID": null,
  },
  MSMQ: {
    "PRIVATE_PUBLIC": null,
    "QUEUE_NAME": null,
    "URL": null,
    "DOMAIN": null,
    "USERNAME": null,
    "PASSWORD": null,
    "useNTLMv1": null,
    "NTLMv2": null,
    "DEADLETTER": null,
    "TRANSACTIONAL": null,
    "MSMQ_AUTOCOMMIT": null,
    "ACK": null,
    "APPSPECIFIC": null,
    "AUTHLEVEL": null,
    "DELIVERY": null,
    "JOURNAL": null,
    "LABEL": null,
    "MAXTIMETOREACHQUEUE": null,
    "MAXTIMETORECEIVE": null,
    "PRIORITY": null,
    "PRIVLEVEL": null,
    "TRACE": null,
    "HASHALGORITHM": null,
  },
  BridgeGateMSMQ: {
    "PRIVATE_PUBLIC": null,
    "QUEUE_NAME": null,
    "URL": null,
    "DOMAIN": null,
    "USERNAME": null,
    "PASSWORD": null,
    "useNTLMv1": null,
    "NTLMv2": null,
    "DEADLETTER": null,
    "TRANSACTIONAL": null,
    "MSMQ_AUTOCOMMIT": null,
  },
  "BridgeGateWebService": {
    "CONNECTIONSTRING": null,
    "SERVICE_NAME": null,
    "TARGET_NAMESPACE": null,
    "AUTHENTICATE": null,
    "USERNAME": null,
    "PASSWORD": null,
    "SOAP_USE_ENVELOPE_AS_RESULT": null,
    "WRITE_SOAP_BODY": null,
    "SEND_SOURCE_AS_SOAP_BODY": null,
    "SYNCHRONOUS": null,
    "OPERATIONS": null
  },
  "GOOGLE_CLOUD_STORAGE": {
    "OAUTH_REDIRECT_URL": null,
    "CLIENT_ID": null,
    "CLIENT_SECRET": null,
    "BUCKET_NAME": null,
    "OBJECT_NAME": null,
    "RETURN_DATA": null,
  },
  "Google Cloud Storage": {
    "OAUTH_REDIRECT_URL": null,
    "CLIENT_ID": null,
    "CLIENT_SECRET": null,
    "BUCKET_NAME": null,
    "OBJECT_NAME": null,
    "RETURN_DATA": null,
    "PROJECT_ID": null,
    "CREDENTIALS_JSON": null,
  },
  GraphQL: {
    "CONNECTIONSTRING": null,
    "USERNAME": null,
    "PASSWORD": null,
    "KEY_ALIAS": null,
    "TIMEOUT": null,
    "URLENCODE": null,
    "FORCE_HOST_VERIFICATION": null,
    "SYNCHRONOUS": null,
    "SSL_TYPE": null,
    "REQUEST_TYPE": null,
    "CONTENT_TYPE": null,
    "ZIP": null,
    "FILE_NAME_WITHIN_ZIP": null,
    "ZIP_PASSWORD": null,
    "USE_ZIP_PASSWORD": null,
    "DECOMPRESSION_DIRECTORY": null,
    "SPECIFY_DECOMPRESSION_DIRECTORY": null,
    "HTTP_CUSTOM_HEADER_FIELDS": null,
    "COMPRESSION": null,
    "COMPRESSION_TYPE": null,
    "FORM_DATA": null,
  },
  JMS: {
    "CONNECTION_FACTORY_LOOKUP":null,
    "CTX_FACTORY": null,
    "INIT_URL": null,
    "DESTINATION_TYPE": null,
    "QUEUE_OR_TOPIC_NAME": null,
    "DURABLE_SUBSCRIPTION_CLIENT_ID": null,
    "USERNAME": null,
    "PASSWORD": null,
  }
  // Add other Adapter Type configurations here as needed.
};